import { createRemoteParamsFeature } from '../../remote-params/create-remote-params-feature';

export const {
  feature: cryptotokenSlotsFeature,
  actions: CryptotokenSlotsActions,
  pipes: CryptotokenSlotsPipes,
  createEffects: createCryptotokenSlotsEffects,
} = createRemoteParamsFeature<'Cryptotoken Slots', string[]>(
  'Cryptotoken Slots',
);

const { selectIsLoading } = cryptotokenSlotsFeature;

export const CryptotokenSlotsSelectors = { selectIsLoading };
